import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { CustomerEditRoute } from "./CustomerEditRoute";
import CustomerEditRouteQueryNode, {
  type CustomerEditRouteQuery$variables,
} from "./__generated__/CustomerEditRouteQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof CustomerEditRoute> = {
  root: JSResource("CustomerEditRoute", () =>
    import("./CustomerEditRoute").then((module) => module.CustomerEditRoute),
  ),
  getPreloadProps({ params }) {
    const variables: CustomerEditRouteQuery$variables = {
      id: params.id!,
    };

    return {
      queries: {
        query: {
          parameters: CustomerEditRouteQueryNode,
          variables,
        },
      },
    };
  },
};

export default entryPoint;
